export const DRAWER_WIDTH_IN_PX = 200;

export const PASTEBIN_DEV_KEY = 'gBaedsFs6A_XtkwGtvmOduIwLWDbTkJF'